export const V1_TABLET_WIDTH = 'max-w-[768px]'
export const V1_MOBILE_WIDTH = 'max-w-[480px]'
